export default __webpack_public_path__ + "static/media/wwr-subImg3.3e9602a6.webp";